const doc = [({"ko":({"adminConstantHotelChildrenSettingPriceType":({"fixed":"고정 요금", "fixedDiscount":"성인 요금에서 지정된 금액을 할인", "free":"무료", "percent":"성인 요금의 비율"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;